<template>
  <div class="fm-grid-scroll" @click.self="$emit('select', null)">
    <div class="fm-grid">
      <FMItemCard
        v-for="item in items"
        :key="item.uid"
        :item="item"
        :selected="selected.includes(item.uid)"
        :drag-target="dragTarget === item.uid"
        view="grid"
        @open="$emit('open', item)"
        @select="$emit('select', item.uid)"
        @select-only="$emit('select-only', item.uid)"
        @context="$emit('context', $event)"
        @drag-start="$emit('drag-start', $event)"
        @drag-over-item="$emit('drag-over-item', $event)"
        @drop-on-item="$emit('drop-on-item', $event)"
      />
    </div>
  </div>
</template>

<script>
import FMItemCard from './FMItemCard.vue'
export default {
  name: 'FMGrid',
  components: { FMItemCard },
  props: { items: Array, selected: Array, dragTarget: String },
}
</script>

<style scoped>
.fm-grid-scroll { flex: 1; overflow-y: auto; padding: 20px; }
.fm-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
}
</style>
